export const AGENT_URL = `${window.envConfig['REACT_APP_APIM_BASE_URL']}${window.envConfig['REACT_APP_APIM_AGENT']}`;
export const CORE_URL = `${window.envConfig['REACT_APP_APIM_BASE_URL']}${window.envConfig['REACT_APP_APIM_CORE']}`;
export const PUBLIC_URL = `${window.envConfig['REACT_APP_APIM_BASE_URL']}${window.envConfig['REACT_APP_APIM_PUBLIC']}`;
export const MANAGER_URL = `${window.envConfig['REACT_APP_APIM_BASE_URL']}${window.envConfig['REACT_APP_APIM_MANAGER']}`;
export const MESSAGE_URL = `${window.envConfig['REACT_APP_APIM_BASE_URL']}${window.envConfig['REACT_APP_ADMIN_NOTIFICATION_URL']}`;

export const MY_AGENT_ENDPOINT = 'agents/me';
